// utils/extract.js
export const extractList = (d) => {
  if (Array.isArray(d)) return d;
  if (!d || typeof d !== "object") return [];
  if (Array.isArray(d.body)) return d.body;
  if (Array.isArray(d.data)) return d.data;
  if (Array.isArray(d.items)) return d.items;
  if (Array.isArray(d.results)) return d.results;
  if (d.body && Array.isArray(d.body.data)) return d.body.data;
  if (d.data && Array.isArray(d.data.items)) return d.data.items;
  return [];
};

export const buildEquiposMap = (equiposArr) => {
  const map = {};
  for (const eq of equiposArr || []) {
    const key = String(eq.cod_servicio ?? eq.cod_servicio_cliente ?? "");
    if (!key) continue;
    if (!map[key]) map[key] = {};
    const tipo = String(eq.tipo ?? "Desconocido");
    const cantidad = Number(eq.cantidad ?? 0);
    map[key][tipo] = (map[key][tipo] || 0) + cantidad;
  }
  return map;
};
